/**
 *
 * @param $locationProvider
 */
export default function locationProviderConfig(
  $locationProvider
) {
  'ngInject';
  $locationProvider.html5Mode(true);
}


/** WEBPACK FOOTER **
 ** ./frontend/config/locationProvider.config.js
 **/